import { getAxiosClient } from "../config/axios";

const getCustomersBaseEndpoint = (endpoint) => {
  return `/api/v1/pga/customers${endpoint ?? ""}`;
};

const CustomersApiClient = {
  fetchClientsList: (
    page,
    size,
    sortBy,
    sortOrder,
    searchText,
    integrationId
  ) => {
    return getAxiosClient().get(getCustomersBaseEndpoint(), {
      params: {
        page,
        size,
        sortBy,
        sortOrder,
        searchText,
        integrationId,
      },
    });
  },
  fetchCompanyName: (integrationId) => {
    return getAxiosClient().get(
      getCustomersBaseEndpoint(`/${integrationId}/name`)
    );
  },
  getNngWsCustomer: (integrationId) => {
    return getAxiosClient().get(
      getCustomersBaseEndpoint(`/getNngWsCustomer/${integrationId}`)
    );
  },
  refreshCache: (customerId, integrationId, refreshType) => {
    return getAxiosClient().get(
      getCustomersBaseEndpoint(
        `/refresh-cache/${customerId}/integrationId/${integrationId}`), {
          params: {
            refreshType
          }
        }
    );
  },
};

export default CustomersApiClient;
